var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppNavigationItem",
    {
      attrs: {
        loading: _vm.calendar.loading,
        title:
          _vm.calendar.displayName || _vm.$t("calendar", "Untitled calendar"),
        "menu-open": _vm.menuOpen
      },
      on: {
        "update:menuOpen": function($event) {
          _vm.menuOpen = $event
        },
        "update:menu-open": function($event) {
          _vm.menuOpen = $event
        },
        click: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.toggleEnabled($event)
        }
      }
    },
    [
      _vm.calendar.enabled
        ? _c("AppNavigationIconBullet", {
            attrs: { slot: "icon", color: _vm.calendar.color },
            on: {
              click: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.toggleEnabled($event)
              }
            },
            slot: "icon"
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "template",
        { slot: "counter" },
        [
          _c("Avatar", {
            attrs: {
              user: _vm.owner,
              "is-guest": true,
              "disable-tooltip": true,
              "disable-menu": true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "actions" },
        [
          _vm.showCopySubscriptionLinkLabel
            ? _c(
                "ActionButton",
                {
                  attrs: { icon: "icon-calendar-dark" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.copySubscriptionLink($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("calendar", "Copy subscription link")) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCopySubscriptionLinkSpinner
            ? _c("ActionText", { attrs: { icon: "icon-loading-small" } }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("calendar", "Copying link …")) +
                    "\n\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showCopySubscriptionLinkSuccess
            ? _c("ActionText", { attrs: { icon: "icon-calendar-dark" } }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("calendar", "Copied link")) +
                    "\n\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showCopySubscriptionLinkError
            ? _c("ActionText", { attrs: { icon: "icon-calendar-dark" } }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("calendar", "Could not copy link")) +
                    "\n\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ActionLink",
            {
              attrs: {
                icon: "icon-download",
                target: "_blank",
                href: _vm.downloadUrl
              }
            },
            [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.$t("calendar", "Download")) + "\n\t\t"
              )
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }